<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Información del Turno</p>
        <button class="delete" aria-label="close" @click="cancelar"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label">A nombre de</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder="A nombre de"
                  v-model="turno.responsable"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Fecha</label>
              <div class="control">
                <input class="input" type="date" placeholder="Fecha" v-model="turno.fecha" disabled />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Saldo Inicial</label>
              <div class="control">
                <input
                  class="input"
                  type="number"
                  placeholder="Saldo Inicial"
                  v-model="turno.sInicial"
                  :disabled="turno._id"
                />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Saldo Final</label>
              <div class="control">
                <input
                  class="input"
                  type="number"
                  placeholder="Saldo Final"
                  v-model="turno.sFinal"
                  :disabled="!turno._id"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-info"
          @click="saveturno"
        >{{turno._id ? 'Cerrar Caja' : 'Abrir Caja'}}</button>
        <button class="button" @click="cancelar">Cancelar</button>
      </footer>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  props: {
    show: {
      type: Boolean,
    },
    turno: {
      type: Object,
    },
  },
  methods: {
    cancelar() {
      this.$emit("closemodal");
    },
    async saveturno() {
      try {
        let result;
        if (this.turno._id) {
          result = await apiServices.put(
            `/turno/${this.turno._id}`,
            this.turno
          );
        } else {
          result = await apiServices.post(`/turno`, this.turno);
        }
        if (result.data) {
          this.$emit("resultturno", result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/Modalcashbox.vue